// extracted by mini-css-extract-plugin
export default {"scrollable":"CreateTable_scrollable__Kxmro"};